// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3Wk3X","file":"styles_file__3SBqr"};